import React, { useEffect, useState } from "react";
import "./Orders.css";
import html2pdf from "html2pdf.js";

function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openOrderId, setOpenOrderId] = useState(null);
  const [invoiceLoadingId, setInvoiceLoadingId] = useState(null);
  const [trackingLoadingId, setTrackingLoadingId] = useState(null);
  const [trackingByOrderId, setTrackingByOrderId] = useState({});
  const [trackingErrorByOrderId, setTrackingErrorByOrderId] = useState({});

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const parseApiJson = async (res) => {
    const text = await res.text();
    const jsonStart = text.indexOf("{");

    if (jsonStart === -1) {
      throw new Error("Invalid API response");
    }

    return JSON.parse(text.slice(jsonStart));
  };

  const downloadInvoice = async (orderId, orderNo) => {
    try {
      setInvoiceLoadingId(orderId);

      const res = await fetch(
        `https://aethearia.store/superadmin/api/invoice-data/${orderId}`
      );

      // because backend can send PHP deprecated warning before JSON
      const data = await parseApiJson(res);

      if (!data.status) {
        throw new Error("Invoice data not found");
      }

      const formatAmount = (amount) =>
        Number(amount || 0).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

      const safeText = (value) =>
        String(value || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");

      const invoiceHtml = `
        <div style="font-family: Arial, sans-serif; padding: 30px; color: #2d241a;">
          <div style="display:flex; justify-content:space-between; border-bottom:1px solid #ddd; padding-bottom:20px;">
            <div>
              <h1 style="margin:0; color:#4c144e;">Aethearia Candle</h1>
              <p style="margin:6px 0 0;">Invoice</p>
            </div>

            <div style="text-align:right;">
              <h3 style="margin:0;">Invoice No.</h3>
              <p style="margin:6px 0;">${safeText(data.invoice.invoice_no)}</p>
              <p style="margin:0;">${safeText(data.invoice.invoice_date)}</p>
            </div>
          </div>

          <div style="display:flex; justify-content:space-between; margin-top:25px;">
            <div>
              <h3 style="margin-bottom:8px;">Bill To</h3>
              <p style="margin:4px 0;"><strong>${safeText(data.customer.name)}</strong></p>
              <p style="margin:4px 0;">${safeText(data.customer.email)}</p>
              <p style="margin:4px 0;">${safeText(data.customer.phone)}</p>
              <p style="margin:4px 0;">
                ${safeText(data.customer.address)}
                ${data.customer.apartment ? ", " + safeText(data.customer.apartment) : ""}
              </p>
              <p style="margin:4px 0;">
                ${safeText(data.customer.city)}, ${safeText(data.customer.state)}, ${safeText(data.customer.country)} - ${safeText(data.customer.pincode)}
              </p>
            </div>

            <div style="text-align:right;">
              <h3 style="margin-bottom:8px;">Payment</h3>
              <p style="margin:4px 0;">Method: ${safeText(data.invoice.payment_method)}</p>
              <p style="margin:4px 0;">Status: ${safeText(data.invoice.payment_status)}</p>
              <p style="margin:4px 0;">Order Status: ${safeText(data.invoice.order_status)}</p>
            </div>
          </div>

          <table style="width:100%; border-collapse:collapse; margin-top:30px;">
            <thead>
              <tr style="background:#f8f3ec;">
                <th style="border:1px solid #ddd; padding:10px; text-align:left;">Product</th>
                <th style="border:1px solid #ddd; padding:10px;">Qty</th>
                <th style="border:1px solid #ddd; padding:10px;">Price</th>
                <th style="border:1px solid #ddd; padding:10px;">Total</th>
              </tr>
            </thead>

            <tbody>
              ${data.items
                .map((item) => {
                  const productName =
                    item.product_name ||
                    String(item.product_slug || "Product").replaceAll("-", " ");

                  return `
                    <tr>
                      <td style="border:1px solid #ddd; padding:10px; text-transform:capitalize;">
                        ${safeText(productName)}
                      </td>
                      <td style="border:1px solid #ddd; padding:10px; text-align:center;">
                        ${safeText(item.quantity)}
                      </td>
                      <td style="border:1px solid #ddd; padding:10px; text-align:right;">
                        ₹${formatAmount(item.price)}
                      </td>
                      <td style="border:1px solid #ddd; padding:10px; text-align:right;">
                        ₹${formatAmount(item.total)}
                      </td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>

          <div style="width:320px; margin-left:auto; margin-top:25px;">
            <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
              <span>Subtotal</span>
              <strong>₹${formatAmount(data.summary.subtotal)}</strong>
            </div>

            <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
              <span>Shipping</span>
              <strong>₹${formatAmount(data.summary.shipping_charge)}</strong>
            </div>

            <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
              <span>Discount</span>
              <strong>₹${formatAmount(data.summary.discount)}</strong>
            </div>

            <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
              <span>Tax</span>
              <strong>₹${formatAmount(data.summary.tax)}</strong>
            </div>

            <div style="display:flex; justify-content:space-between; border-top:1px solid #ddd; padding-top:12px; font-size:20px;">
              <span>Total</span>
              <strong>₹${formatAmount(data.summary.grand_total)}</strong>
            </div>
          </div>

          <p style="margin-top:40px; text-align:center; color:#777;">
            Thank you for shopping with Aethearia Candle.
          </p>
        </div>
      `;

      const element = document.createElement("div");
      element.innerHTML = invoiceHtml;

      const options = {
        margin: 0,
        filename: `invoice-${orderNo || data.invoice.invoice_no || orderId}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      await html2pdf().set(options).from(element).save();
    } catch (error) {
      console.error(error);
      alert("Unable to download invoice");
    } finally {
      setInvoiceLoadingId(null);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);

      const payload = user?.id
        ? {
            user_id: user.id,
            guest_id: "",
          }
        : {
            guest_id: localStorage.getItem("guest_id"),
            user_id: "",
          };

      const res = await fetch(
        "https://aethearia.store/superadmin/api/all-orders",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (data.status && Array.isArray(data.data)) {
        setOrders(data.data);

        if (data.data.length > 0) {
          setOpenOrderId(data.data[0].id);
        }
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.log(error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTracking = async (orderId) => {
    if (!orderId) {
      alert("Order ID not found");
      return;
    }

    try {
      setTrackingLoadingId(orderId);
      setTrackingErrorByOrderId((prev) => ({ ...prev, [orderId]: "" }));

      const res = await fetch(
        "https://aethearia.store/superadmin/api/track-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: Number(orderId),
          }),
        }
      );

      const data = await parseApiJson(res);

      console.log("Track Order Response:", data);

      if (data.status && data.tracking?.tracking_data) {
        setTrackingByOrderId((prev) => ({
          ...prev,
          [orderId]: data.tracking.tracking_data,
        }));
      } else {
        setTrackingByOrderId((prev) => ({ ...prev, [orderId]: null }));
        setTrackingErrorByOrderId((prev) => ({
          ...prev,
          [orderId]: data.message || "Tracking details are not available yet.",
        }));
      }
    } catch (error) {
      console.error("Track order error:", error);
      setTrackingByOrderId((prev) => ({ ...prev, [orderId]: null }));
      setTrackingErrorByOrderId((prev) => ({
        ...prev,
        [orderId]: "Unable to fetch tracking details. Please try again.",
      }));
    } finally {
      setTrackingLoadingId(null);
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (date) => {
    if (!date || date === "NA") return "N/A";

    const parsedDate = new Date(String(date).replace(" ", "T"));

    if (Number.isNaN(parsedDate.getTime())) {
      return date;
    }

    return parsedDate.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const cleanValue = (value) => {
    if (!value || value === "NA") return "N/A";
    return value;
  };

  const toggleOrder = (id) => {
    setOpenOrderId(openOrderId === id ? null : id);
  };

  return (
    <div className="orders-container">
      <style>{`
        .order-actions{
          display:flex;
          align-items:center;
          gap:10px;
          flex-wrap:wrap;
        }

        .track-order-btn{
          background:#fff;
          color:#4c144e;
          border:1px solid #4c144e;
        }

        .track-order-box{
          margin-top:18px;
          border:1px solid #eadcc9;
          background:#fffaf3;
          padding:18px;
          border-radius:5px;
        }

        .tracking-top{
          display:flex;
          justify-content:space-between;
          align-items:flex-start;
          gap:14px;
          padding-bottom:14px;
          border-bottom:1px solid #eadcc9;
        }

        .tracking-label{
          display:block;
          font-size:12px;
          color:#7a6f63;
          margin-bottom:5px;
        }

        .tracking-status{
          display:inline-block;
          background:#664e64;
          color:#fff;
          padding:7px 12px;
          border-radius:5px;
          font-size:14px;
          font-weight:100;
        }

        .tracking-link{
          color:#4c144e;
          text-decoration:underline;
          font-size:14px;
          font-weight:100;
          white-space:nowrap;
        }

        .tracking-grid{
          display:grid;
          grid-template-columns:repeat(2, minmax(0, 1fr));
          gap:12px;
          margin-top:15px;
        }

        .tracking-item{
          background:#fff;
          border:1px solid #f0e4d5;
          padding:12px;
          border-radius:5px;
        }

        .tracking-item span{
          display:block;
          font-size:14px;
          color:#7a6f63;
          margin-bottom:5px;
        }

        .tracking-item strong{
          display:block;
          font-size:14px;
          color:#2d241a;
          word-break:break-word;
        }

        .tracking-timeline{
          margin-top:18px;
        }

        .tracking-timeline h5{
          margin:0 0 12px;
          font-size:14px;
          color:#2d241a;
        }

        .timeline-row{
          display:flex;
          gap:12px;
          position:relative;
          padding-bottom:14px;
        }

        .timeline-dot{
          width:10px;
          height:10px;
          border-radius:50%;
          background:#4c144e;
          flex:0 0 10px;
          margin-top:4px;
        }

        .timeline-content{
          flex:1;
        }

        .timeline-content strong{
          display:block;
          font-size:14px;
          color:rgb(77,67,56,1);
          margin-bottom:3px;
        }

        .timeline-content p{
          margin:0 0 3px;
          font-size:14px;
          color:rgb(67,67,56,1);
        }

        .tracking-error{
          margin-top:12px;
          color:#b00020;
          background:#fff;
          border:1px solid #f1c7c7;
          padding:12px;
          border-radius:5px;
          font-size:13px;
        }

        @media(max-width:768px){
          .tracking-top{
            flex-direction:column;
          }

          .tracking-grid{
            grid-template-columns:1fr;
          }
        }
          @media(max-width:768px){
  .order-actions{
    width:100%;
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:8px;
    flex-wrap:nowrap;
  }

  .order-actions .view-details-btn{
    width:100%;
    min-width:0;
    padding:10px 8px;
    font-size:12px;
    white-space:nowrap;
  }
}
  .track-order-box {
  margin-top: 18px;
  border: 1px solid #eadcc9;
  background: #fffaf3;
  padding: 18px;
  border-radius: 5px;

  /* Scroll */
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;

  box-sizing: border-box;
  width: 100%;
}

/* Custom scrollbar */
.track-order-box::-webkit-scrollbar {
  width: 6px;
}

.track-order-box::-webkit-scrollbar-track {
  background: #f5eee5;
  border-radius: 10px;
}

.track-order-box::-webkit-scrollbar-thumb {
  background: #4c144e;
  border-radius: 10px;
}

.track-order-box::-webkit-scrollbar-thumb:hover {
  background: #664e64;
}
  @media (max-width: 768px) {
  .track-order-box {
    width: 100%;
    max-width: 100%;
    max-height: 400px;
    padding: 12px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .tracking-grid {
    grid-template-columns: 1fr;
  }
}
  .track-order-box {
  margin-top: 18px;
  border: 1px solid #eadcc9;
  background: #fffaf3;
  padding: 18px;
  border-radius: 5px;

  width: 100%;
  max-width: 100%;
  max-height: 450px;

  /* Always show vertical scrollbar */
  overflow-y: scroll;
  overflow-x: hidden;

  box-sizing: border-box;

  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #4c144e #eadcc9;
}

/* Chrome, Edge, Safari */
.track-order-box::-webkit-scrollbar {
  width: 10px;
}

.track-order-box::-webkit-scrollbar-track {
  background: #eadcc9;
  border-radius: 5px;
}

.track-order-box::-webkit-scrollbar-thumb {
  background: #4c144e;
  border-radius: 5px;
  border: 2px solid #eadcc9;
}

.track-order-box::-webkit-scrollbar-thumb:hover {
  background: #664e64;
}
      `}</style>

      <h2 className="orders-title">My Orders</h2>

      {loading ? (
        <div className="orders-loading">Loading your orders...</div>
      ) : orders.length === 0 ? (
        <div className="empty-orders">
          <h3>No orders found</h3>
          <p>Your placed orders will appear here.</p>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map((order) => {
            const isOpen = openOrderId === order.id;
            const trackingData = trackingByOrderId[order.id];
            const trackingInfo = trackingData?.shipment_track?.[0];
            const trackingActivities = trackingData?.shipment_track_activities || [];
            const trackingError = trackingErrorByOrderId[order.id];

            return (
              <div className={`order-card ${isOpen ? "active" : ""}`} key={order.id}>
                <button
                  className="order-header"
                  onClick={() => toggleOrder(order.id)}
                >
                  <div className="order-left">
                    <h4>Order #{order.order_no}</h4>
                    <p>{formatDate(order.created_at)}</p>
                  </div>

                  <div className="order-right">
                    <span className="order-status">{order.shiprocket_status}</span>
                    <span className={`accordion-icon ${isOpen ? "rotate" : ""}`}>
                      +
                    </span>
                  </div>
                </button>

                <div className={`order-accordion ${isOpen ? "show" : ""}`}>
                  <div className="order-products">
                    {order.products?.map((product, index) => (
                      <div className="product-row" key={index}>
                        <img
                          src={`https://aethearia.store/superadmin/uploads/products/Hero/${product.hero_image}`}
                          alt={product.product_name}
                        />

                        <div className="product-info">
                         

                          <div className="product-meta" style={{alignItems: 'center'}}>
                            <p>Qty: {product.quantity}</p>
                             <h5>{product.product_name}</h5>
                            <p>₹{product.price}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="order-bottom">
                    <div className="order-actions">
                      <button
                        className="view-details-btn"
                        onClick={() => downloadInvoice(order.id, order.order_no)}
                        disabled={invoiceLoadingId === order.id}
                      >
                        {invoiceLoadingId === order.id ? "Downloading..." : "Download Invoice"}
                      </button>

                      <button
                        className="view-details-btn track-order-btn"
                        onClick={() => fetchTracking(order.id)}
                        disabled={trackingLoadingId === order.id}
                      >
                        {trackingLoadingId === order.id ? "Tracking..." : "Track Order"}
                      </button>
                    </div>

                    <div className="order-footer">
                      <strong>Total: ₹{order.subtotal}</strong>
                      <span>Payment: {order.payment_method}</span>
                    </div>
                  </div>

                  {trackingError && (
                    <div className="tracking-error">{trackingError}</div>
                  )}

                  {trackingInfo && (
                    <div className="track-order-box">
                      <div className="tracking-top">
                        <div>
                          <span className="tracking-label">Current Status</span>
                          <span className="tracking-status">
                            {cleanValue(trackingInfo.current_status)}
                          </span>
                        </div>

                        {trackingData?.track_url && (
                          <a
                            className="tracking-link"
                            href={trackingData.track_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View Live Tracking
                          </a>
                        )}
                      </div>

                      <div className="tracking-grid">
                        <div className="tracking-item">
                          <span>AWB Code</span>
                          <strong>{cleanValue(trackingInfo.awb_code)}</strong>
                        </div>

                        <div className="tracking-item">
                          <span>Courier</span>
                          <strong>{cleanValue(trackingInfo.courier_name)}</strong>
                        </div>

                        <div className="tracking-item">
                          <span>Estimated Delivery</span>
                          <strong>
                            {formatDateTime(trackingData?.etd || trackingInfo.edd)}
                          </strong>
                        </div>

                        <div className="tracking-item">
                          <span>Destination</span>
                          <strong>{cleanValue(trackingInfo.destination)}</strong>
                        </div>

                        <div className="tracking-item">
                          <span>Consignee</span>
                          <strong>{cleanValue(trackingInfo.consignee_name)}</strong>
                        </div>

                        <div className="tracking-item">
                          <span>Last Updated</span>
                          <strong>{formatDateTime(trackingInfo.updated_time_stamp)}</strong>
                        </div>
                      </div>

                      {trackingActivities.length > 0 && (
                        <div className="tracking-timeline">
                          <h5>Tracking Timeline</h5>

                          {trackingActivities.map((activity, index) => (
                            <div className="timeline-row" key={`${activity.date}-${index}`}>
                              <span className="timeline-dot"></span>

                              <div className="timeline-content">
                                <strong>{cleanValue(activity.status)}</strong>
                                <p>{cleanValue(activity.activity)}</p>
                                <p>
                                  {formatDateTime(activity.date)} • {cleanValue(activity.location)}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Orders;
